import { Box, Grid, styled as MUIstyled, Tab, Tabs, styled } from "@mui/material";
import { IPurchaseState } from "@smartrr/shared/entities/PurchaseState";
import { ScheduledDeliveryGroupWithPurchSt } from "@smartrr/shared/entities/PurchaseState/scheduleUtils";
import { rgba } from "polished";

import { ProductImage } from "../../../components/ProductImage";

// @todo: the previous import of 'shopify-assets/src' works in app but not in tests
// thats an odd import since within the scope of this we are 'shopify-assets'
// since that is breaking the test I've added the relative import for now
import { VariantImage } from "../../../components/VariantImage";

export interface ISubscriptionProps {
  upcomingDelivery: ScheduledDeliveryGroupWithPurchSt<IPurchaseState>;
}

export const OrderItemImage = styled(ProductImage)`
  background-color: transparent;
  height: ${props => props.size !== "small" && "90px"};
  opacity: ${props => (props.disabled ? "60%" : "100%")};
  width: ${props => props.size !== "small" && "90px"};

  & .smartrr-portal-product-image-wrapper {
    height: max-content;
    width: max-content;
  }

  & img {
    border-radius: ${({ theme, size }) =>
      size === "small" ? `${theme.modernSmallImageBorderRadius}px` : `${theme.modernImageBorderRadius}px`};
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
  & [class*="fallback-image"] {
    border-radius: ${({ theme, size }) =>
      size === "small" ? `${theme.modernSmallImageBorderRadius}px` : `${theme.modernImageBorderRadius}px`};
  }
`;

export const OrderVariantImage = styled(VariantImage)`
  background-color: transparent;
  height: ${props => props.size !== "small" && "90px"};
  opacity: ${props => (props.disabled ? "60%" : "100%")};
  width: ${props => props.size !== "small" && "90px"};

  & .smartrr-portal-product-image-wrapper {
    height: max-content;
    width: max-content;
  }

  & img {
    border-radius: ${({ theme, size }) =>
      size === "small" ? `${theme.modernSmallImageBorderRadius}px` : `${theme.modernImageBorderRadius}px`};
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  & [class*="fallback-image"] {
    border-radius: ${({ theme, size }) =>
      size === "small" ? `${theme.modernSmallImageBorderRadius}px` : `${theme.modernImageBorderRadius}px`};
  }
`;

export const GridWrapper = styled("div")`
  align-items: center;
  display: flex;
  position: relative;
`;

export const AddOnHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  height: 30px;
  justify-content: space-between;
`;

export const AddOnSectionWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  transition: 0.3s ease-in-out;
`;

export const OverflowGrid = styled(Grid)`
  direction: ltr;
  height: max-content;
  max-height: 100%;
  width: max-content;
  will-change: transform;
`;

export const VerticalProductWrapper = MUIstyled(Grid)`
  padding: 10px;
  transition: 0.3s ease-in-out;
  width: 110px;

  & > * {
    max-width: 90px;
  }
  & p {
    margin-bottom: 3px;
  }

  & button {
    height: 30px;
    margin: 7px 0;
  }

  & img,
  & .smartrr-portal-product-image-container,
  & .smartrr-portal-product-image-wrapper {
    height: 90px;
    width: 90px;
  }

  &[class*="disabled"] {
    pointer-events: none;
    &:hover {
      background-color: inherit;
    }
  }

  &[class*="unavailable"]{
    pointer-events: all !important;
  }

  &[class*="list-item"],
  &[class*="list-item-selected"],
  &[class*="addon-selected"] {
    border-radius: ${props => props.theme.modernCardRadius}px;
  }
  &[class*="list-item"]:not([class*="list-item-prepaid"]):hover,
  &[class*="list-item-selected"]:hover {
    background-color: ${props => rgba(props?.theme?.modernPageBackground ?? "#F4F4F4", 0.5)};
  }

  &[class*="addon-selected"],
  &[class*="list-item-selected"] {
    background-color: ${props => props.theme.modernPageBackground};
    &:hover{
      background-color: ${props => props.theme.modernPageBackground} !important;
    }
  }
  & [class*="MuiAvatar-root"]{
    border: 3px dashed ${props => props.theme.modernLineDividers};
    width: 90px;
    height: 90px;
    background-color:transparent;
    border-radius: ${props => props.theme.modernImageBorderRadius}px;
  }
`;

export const StyledTabWrapper = MUIstyled(Tabs)`
  .MuiTabs-fixed {
    align-items: end;
    display: flex;
  }
  [class*="tab-button"] {
    background-color: ${props => rgba(props.theme.modernPrimaryButtonColor!, 0.3)};
    color: ${props => props.theme.modernPrimaryButtonFontColor};

    :first-of-type {
      margin-right: 10px;
    }
    svg {
      stroke: ${props => props.theme.modernPrimaryButtonFontColor};
    }
  }

  [class*="selected"] {
    background-color: ${props => props.theme.modernPrimaryButtonColor} !important;
    color: ${props => props.theme.modernPrimaryButtonFontColor} !important;
    svg {
      stroke: ${props => props.theme.modernPrimaryButtonFontColor} !important;
    }
  }
  & [class*="MuiTabs-indicator"] {
    background-color: ${props => props.theme.modernLineDividers};
    height: 1px;
  }
`;

export const StyledTab = MUIstyled(Tab)`
  border-radius: ${props => props.theme.modernButtonBorderRadius}px ${props => props.theme.modernButtonBorderRadius}px 0 0;
  color: ${props => rgba(props.theme.modernCaptionFontColor!, 0.6)};
  font-family: ${props => props.theme.modernCaptionFontFamily};
  font-size: ${props => props.theme.modernCaptionFontSize}px;
  font-weight: light;
  max-height: 46px;
  min-height: 46px;
  &[class*="selected"] {
    color: ${props => props.theme.modernCaptionFontColor};
    font-weight: 500;
    svg {
      stroke: ${props => props.theme.modernIconsColor};
    }
  }
  padding: 15px !important;
  text-transform: uppercase;
  transition: 0.3s ease-in-out;
  svg {
    height: 16px;
    stroke: ${props => rgba(props.theme.modernIconsColor!, 0.6)};
    width: 16px;
  }
`;
